import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import styles from "../RunningLine/RunningLine.module.scss";
import { PUBLIC_ICON } from "../../constants";
import RateCoin from "../RateCoin/RateCoin";
type CoinRate = string;

interface CoinData {
  bitcoin: CoinRate;
  ethereum: CoinRate;
  tether: CoinRate;
  bnb: CoinRate;
  solana: CoinRate;
  xrp: CoinRate;
  spx: CoinRate;
  nasdaq: CoinRate;
  dji: CoinRate;
  gold: CoinRate;
  silver: CoinRate;
}

const RunningLIne = () => {
  const [coinData, setCoinData] = useState<CoinData | null>(() => {
    try {
      return JSON.parse(sessionStorage.getItem("alfa:exchange:header-rates") || "null");
    } catch {
      return null;
    }
  });

  const getCourse = async () => {
    try {
      const endpoint = "/api/v1/exchange/currencies_header";
      const res = await fetch(
        endpoint,
        {
          method: "GET",
        }
      );

      if (!res.ok) {
        throw new Error("Ошибка при получении данных с сервера");
      }

      const data: CoinData = await res.json();

      setCoinData(data);
      sessionStorage.setItem("alfa:exchange:header-rates", JSON.stringify(data));
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса:", error);
    }
  };

  useEffect(() => {
    getCourse();
    const timer = window.setInterval(getCourse, 60_000);
    return () => window.clearInterval(timer);
  }, []);

  if (!coinData) return null;

  return (
    <div className={styles.marquee__wrapper}>
      <Marquee speed={50} autoFill={true}>
        {Object.entries(coinData).map(([key, value]) => {
          if (key === "spx") {
            return (
              <RateCoin
                key={key}
                image={PUBLIC_ICON + "spx.svg"}
                coinName={key}
                coinSecondName={key}
                coinPrice={value}
              />
            );
          }
          if (key === "dji") {
            return (
              <RateCoin
                key={key}
                image={PUBLIC_ICON + "dji.svg"}
                coinName={key}
                coinSecondName={key}
                coinPrice={value}
              />
            );
          }
          return (
            <RateCoin
              key={key}
              image={PUBLIC_ICON + key + ".svg"}
              coinName={key}
              coinSecondName={key}
              coinPrice={value}
            />
          );
        })}
      </Marquee>
    </div>
  );
};

export default RunningLIne;
